import React from 'react';
import ToolCard from '../Shared/ToolCard';
import { motion } from 'framer-motion';

const BotConnectionTools = () => {
  const tools = [
    {
      icon: 'fa-user-shield',
      iconColor: 'text-accent-purple bg-accent-purple',
      title: 'OP Bot',
      description: 'Deploy bots that attempt to gain operator privileges through vulnerabilities.',
      stats: [
        { label: 'Success Rate', value: '32%', colorClass: 'text-accent-purple' },
        { label: 'OP Gained', value: '127', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-purple',
      path: '/bots?type=op'
    },
    {
      icon: 'fa-bolt',
      iconColor: 'text-accent-orange bg-accent-orange',
      title: 'Crash Bot',
      description: 'Test server stability with bots designed to exploit crash vulnerabilities.',
      stats: [
        { label: 'Exploits', value: '14', colorClass: 'text-accent-orange' },
        { label: 'Success', value: '78%', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-orange',
      path: '/bots?type=crash'
    },
    {
      icon: 'fa-key',
      iconColor: 'text-accent-yellow bg-accent-yellow',
      title: 'Account Bot',
      description: 'Deploy bots that attempt to crack authentication and find account passwords.',
      stats: [
        { label: 'Accounts Found', value: '862', colorClass: 'text-accent-yellow' },
        { label: 'Attempts', value: '8.5M', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-yellow',
      path: '/bots?type=account'
    },
  ];

  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <h2 className="text-2xl font-bold mb-5 flex items-center group">
        <div className="w-10 h-10 rounded-lg bg-accent-green/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
          <i className="fas fa-robot text-accent-green"></i>
        </div>
        Bot Connection Tools
        <div className="ml-3 text-xs py-1 px-2 bg-accent-green/20 rounded-full text-accent-green opacity-0 group-hover:opacity-100 transition-medium">
          3 tools available
        </div>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {tools.map((tool, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <ToolCard {...tool} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};


export default BotConnectionTools;